import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setOrderDetails } from '../../actions/orders';

class Index extends Component {
  onQuantityChange(quantity) {
    const { variants, variantSelected } = this.props,
          selectedVariant = variantSelected ? variants.find(v => v.external_id == variantSelected) : {},
          multiplier = selectedVariant ? selectedVariant.unit_multiplier : 1;

    this.props.setOrderDetails({ quantity: quantity, totalQuantity: quantity*multiplier });
  }

  render() {
    const { min = 0, quantity, style: { title, body } } = this.props,
      nextValue = quantity + 1,
      prevValue = quantity - 1 > min ? quantity - 1 : min;

    return (
      <div className="form-row quantity-input">
        <div className="form-row__content">
          <button className="qtyminus" style={{...title}} onClick={() => this.onQuantityChange(prevValue)}>-</button>
          <input
            name="Quantity"
            disabled={true}
            className="qty"
            type="text"
            style={{...title, backgroundColor: body.backgroundColor}}
            onInput={() => {}}
            value={quantity}
          />
          <button className="qtyplus" style={{...title}} onClick={() => this.onQuantityChange(nextValue)}>+</button>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ order, settings, product }) => ({
    variantSelected: order.variantSelected,
    variants: product.data.variants,
    quantity: order.quantity,
    style: settings.style
  }),
  dispatch => ({
    setOrderDetails: (value) => dispatch(setOrderDetails(value)),
  }),
)(Index);
